/* import __COLOCATED_TEMPLATE__ from './address.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class Address extends Component {
  @service store;
  @service notificationsService;
  @service intl;
  @tracked editedAddress;

  constructor() {
    super(...arguments);
    this.editedAddress = this.address?.value || '';
  }

  get address() {
    let emailTemplateData = this.store.peekAll('email-template-data');
    return emailTemplateData.findBy('identifier', 'address');
  }

  @action
  async saveIfDirty() {
    let currentValue = this.address?.value || '';
    if (this.editedAddress !== currentValue) {
      try {
        if (!this.address) {
          await this.store
            .createRecord('email-template-data', {
              identifier: 'address',
              value: this.editedAddress,
            })
            .save();
        } else if (this.editedAddress === '') {
          await this.address.destroyRecord();
        } else {
          this.address.value = this.editedAddress;
          await this.address.save();
        }
      } catch (error) {
        this.notificationsService.notifyError(
          this.intl.t('channels.email.settings.address.save-error'),
        );
      }
    }
  }
}
